import React from 'react';
import {Field, Form, Formik} from 'formik';
import {useParams} from 'react-router-dom';
import CustomButton from 'components/customButton';
import FormikSelect from 'components/formikFields/select';
import UseGetProvince from 'utilities/hooks/province/useGetProvince';
import {
  FindCityAndProvince,
  ProvincesToOption,
  findCityOfProvince,
} from './helper';
import CustomTextArea from './customTextArea';
import {PurchaseRegistrationSchema} from './helper/schema';
import {usePurchase} from 'context/purchaseContext';
import useEditWantedPost from './hooks/useEditWantedPost';
import useGetWantedPost from './hooks/useGetWantedPost';
import DotsLoading from 'components/loadings/dotsLoading';

interface PurchaseRegistrationProps {
  type: 'market' | 'farmer';
}
const PurchaseRegistration = ({type}: PurchaseRegistrationProps) => {
  const params = useParams();

  const {resetForm} = usePurchase();

  const {provinces} = UseGetProvince();
  const {mutate, isLoading} = useEditWantedPost({resetForm});
  const {isLoadingWantedpost, wantedpostData} = useGetWantedPost({
    guid: params?.guid ? params?.guid : '',
  });

  const {city, province} = FindCityAndProvince(
    provinces ? provinces : [],
    wantedpostData?.state ? wantedpostData.state : '',
    wantedpostData?.city ? wantedpostData.city : '',
  );

  return (
    <>
      {isLoadingWantedpost ? (
        <DotsLoading />
      ) : (
        <Formik
          validationSchema={PurchaseRegistrationSchema}
          enableReinitialize={true}
          initialValues={{
            state: province?.id,
            city: city?.id,
            hide_phone_number: wantedpostData?.hide_phone_number
              ? wantedpostData.hide_phone_number
              : false,
            title: wantedpostData?.title ? wantedpostData?.title : '',
          }}
          onSubmit={values => {
            const data: EditwantedBody = {
              profile_type: type,
              guid: params?.purchaseId ? params?.purchaseId : '',
              city: values.city ? values.city : 0,
              state: values.state ? values.state : 0,
              hide_phone_number: values.hide_phone_number,

              title: values.title,
            };

            mutate(data);
          }}
        >
          {({values}) => {
            const cities = values.state
              ? findCityOfProvince(provinces, values.state)
              : [];
            return (
              <Form className="flex flex-col w-full gap-4 px-4 py-4  justify-between mb-4">
                <div className="flex flex-col w-full justify-around gap-4">
                  <div className="flex flex-col w-full gap-2">
                    <span className="font-normal text-[18px] leading-[36px] text-gray-6">
                      متن درخواست:
                    </span>
                    <Field
                      type="textarea"
                      name="title"
                      rows={9}
                      as={CustomTextArea}
                      placeholder="متن گزارش"
                    />
                  </div>
                  <div className="flex flex-col w-full gap-4">
                    <span className="font-normal text-[18px] leading-[36px] text-gray-6 ">
                      محدوده آگهی:
                    </span>
                    <div className="flex flex-col gap-6">
                      <FormikSelect
                        name="state"
                        label="استان"
                        Options={ProvincesToOption(provinces || [])}
                      />
                      <FormikSelect
                        name="city"
                        label="شهرستان"
                        disabled={!values.state}
                        Options={cities ? cities : []}
                      />
                    </div>
                  </div>
                  <div className="flex items-center my-6">
                    <label className="flex items-center gap-4">
                      <Field type="checkbox" name="hide_phone_number" />
                      <span className="text-[14px] font-normal text-gray-6">
                        شماره تلفن در آگهی نمایش داده نشود.
                      </span>
                    </label>
                  </div>
                </div>
                <CustomButton
                  isLoading={isLoading}
                  type="submit"
                  title="ثبت آگهی"
                  className="!bg-primary"
                />
              </Form>
            );
          }}
        </Formik>
      )}
    </>
  );
};

export default PurchaseRegistration;
